import assign from 'lodash/assign';
import uniqBy from 'lodash/uniqBy';
import constants from '../constants';

const initState = () => [];

const search = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.ADD_RECENT_SEARCH) {
    // most recent first, remove dupes
    return assign(uniqBy([].concat(payload).concat(state), 'name'));
  }
  return state;
};

export default search;
